import ENV from "../env";

async function getBartrackQualitySummary(locationUUID, equipmentUUID, fromDate, toDate, bins) {
  try {
    const response = await fetch(`${ENV.firebaseApiUrl}/bartrack/quality-summary`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        location_uuid: locationUUID,
        from_date: fromDate,
        to_date: toDate,
        equipment_uuid: equipmentUUID,
        bins: bins,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Request failed");
    }

    return response.json();
  } catch (error) {
    console.error("Error fetching quality summary:", error.message);
  }
}
export default getBartrackQualitySummary;
